import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserHoldingsService } from '@app/user-holdings/user-holdings.service';
import { AlertService } from '@service/alert.service';

@Component({
  selector: 'app-edit-transaction-dialog',
  templateUrl: './edit-transaction-dialog.component.html',
  styles: [
  ]
})
export class EditTransactionDialogComponent implements OnInit {
  
  oldQuantity = new FormControl();
  newQuantity = new FormControl();
  currentPrice = new FormControl();
  scriptType = 'BUY'

  constructor(
    private dialogRef: MatDialogRef<EditTransactionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public transaction: any,
    private holdingsService: UserHoldingsService,
    private alertService:AlertService
  ) { }

  ngOnInit(): void {
    // this.oldQuantity.patchValue(this.transaction.quantity)
    // this.oldQuantity.disable()
    this.newQuantity.patchValue(this.transaction.quantity)
    this.currentPrice.patchValue(this.transaction.currentPrice)

    this.newQuantity.valueChanges.subscribe((res)=>{
      if(this.oldQuantity.value > this.newQuantity.value){
        this.scriptType = 'SELL';
      } else{
        this.scriptType = 'BUY';
      }
    })
  }

  close(isUpdate: any){
    this.dialogRef.close(isUpdate)
  }

  editTransaction(){
    let data = {
      quantity: this.newQuantity.value,
      purchasePrice: this.currentPrice.value,
      scriptType: this.scriptType,
      investment: (this.newQuantity.value * this.currentPrice.value)
    }
    this.holdingsService.updateTransaction(this.transaction._id, data).subscribe((res)=>{
      this.alertService.success(res.message)
      this.close(true)
    })
  }

  deleteTransaction(){
    this.holdingsService.deleteTransaction(this.transaction._id).subscribe((res)=>{
      this.alertService.success(res.message)
      this.close(true)
    })
  }
}
